
import { RoutineInfo } from "./components/RoutineInfo";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { DeleteRoutineDialog } from "./components/DeleteRoutineDialog";
import { Database } from "@/integrations/supabase/types";
import { DaySelector } from "./components/day-selector/DaySelector";
import { ImageUploader } from "./components/ImageUploader";

type Weekday = Database["public"]["Enums"]["weekday"];

interface RoutineHeaderProps {
  name: string;
  routineId: string;
  showRemoveButton: boolean;
  showExerciseForm: boolean;
  onToggleExerciseForm: () => void;
  onUnlinkRoutine: (routineId: string) => Promise<void>;
  isPersonalPlan: boolean;
  canEdit: boolean;
  day: Weekday;
  hideDaySelector?: boolean;
}

export const RoutineHeader = ({
  name,
  routineId,
  showRemoveButton,
  showExerciseForm,
  onToggleExerciseForm,
  onUnlinkRoutine,
  isPersonalPlan,
  canEdit,
  day,
  hideDaySelector = false,
}: RoutineHeaderProps) => {
  const handleDeleteRoutine = async () => {
    try {
      await onUnlinkRoutine(routineId);
    } catch (error) {
      console.error("❌ RoutineHeader - Error deleting routine:", error);
    }
  };

  // Log render information for debugging
  console.log("🎨 RoutineHeader - Rendering:", {
    routineId,
    name,
    day,
    canEdit,
    isPersonalPlan
  });

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 p-4 rounded-lg bg-[#412C21]/50 backdrop-blur-sm dark:bg-[#0D0D0D] bg-primary/5 sunset:bg-black/30 forest:bg-black/30">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 text-black dark:text-white">
          <RoutineInfo 
            name={name} 
            routineId={routineId} 
            day={day} 
            canEdit={canEdit} 
          />
          <div className="flex flex-wrap sm:flex-row items-center gap-2 w-full sm:w-auto">
            {/* Add Exercise Button - Only show if user can edit */}
            {canEdit && (
              <Button
                onClick={onToggleExerciseForm}
                variant="outline"
                className=" text-primary sunset:bg-[#F26018] sunset:hover:bg-[#F26018] hover:text-white transition-all duration-200 px-3 py-2 sm:px-4 text-sm sm:text-base font-medium"
              >
                <Plus className="mr-1 sm:mr-2 h-4 w-4" />
                {showExerciseForm ? "Cancelar" : "Añadir Ejercicio"}
              </Button>
            )}
            
            {canEdit && (
              <>
                {/* Hide DaySelector when plan is in sequential mode */}
                {!hideDaySelector && (
                  <DaySelector 
                    routineId={routineId} 
                    onDayChange={(days) => {
                      console.log("🔄 RoutineHeader - Days changed for routine:", routineId, days);
                    }}
                  />
                )}
                
                <ImageUploader routineId={routineId} />
              </>
            )}
            {showRemoveButton && (
              <DeleteRoutineDialog onDelete={handleDeleteRoutine} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
